import * as React from "react";
import { IParagraphSiteOffersProps } from "./ParagraphSiteOffersProps";
import { Container } from "./ParagraphSiteOffersHelpers";
import { graphql, Slice } from "gatsby";
import { SiteOffersSliceProvider } from "../../../context/SliceContexts/SiteOffersContext";

const ParagraphSiteOffers: React.FC<IParagraphSiteOffersProps> = (props) => {
  return (
    <Container>
      <SiteOffersSliceProvider
        value={{
          relationships: props.node.relationships,
          location: props.node.location,
          field_subtitle: props.node.field_subtitle,
          field_title: props.node.field_title,
          field_description: props.node.field_description,
        }}
      >
        <Slice alias="site-offers" />
      </SiteOffersSliceProvider>
    </Container>
  );
};

export const fragment = graphql`
  fragment ParagraphSiteOffers on paragraph__site_offers {
    id
    parent_type
    field_subtitle
    field_promo_code
    field_title
    field_description
    relationships {
      background: field_background {
        type: __typename
        ...ParagraphBackground
      }
      offers: field_node_offers {
        id
        title
        field_subtitle
        field_promo_code
        field_minimum_length_stay
        field_lead_days
        field_external_link {
          url
          title
        }
        path {
          alias
        }
        description: body {
          summary
          processed
          value
        }
        relationships {
          field_site_list {
            machine_name
          }
          field_rate_code {
            code
          }
          field_teaser_image {
            relationships {
              field_media_image {
                gatsbyImage(
                  width: 640
                  height: 480
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }
    }
  }
`;
export default ParagraphSiteOffers;
